import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import {
  getCorrespondingAppUrl,
  detectPlatform
} from "@src/template/helpers/nativeAppBanner";
import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";

const buildAppDownloadUrl = (baseUrl, ctaRef, defaultStoreUrl) => {
  const url = new URL(defaultStoreUrl.concat(baseUrl));
  if (ctaRef) {
    url.searchParams.set("ctaRef", ctaRef);
  }
  return url.toString();
};

export const useGetAppDownloadUrl = ({ ctaRef, defaultStoreUrl }) => {
  const [customerId, setCustomerId] = useState(null);
  const [appDownloadUrl, setAppDownloadUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [osPlatform, setOsPlatform] = useState(null);

  const baseAppDownloadUrl = "discover/our-apps/";

  useEffect(() => {
    setOsPlatform(detectPlatform());
  }, []);

  useEffect(() => {
    const getCustomerIdFromIdentitySdk = async () => {
      try {
        const identity = await sdkInstanceProvider("identity");
        const profile = await identity.customer.profile();
        setCustomerId(profile.customerId);
      } catch (_) {} // eslint-disable-line no-empty
    };

    getCustomerIdFromIdentitySdk();
  }, []);

  useEffect(() => {
    let appUrl;

    try {
      // Only use platform-specific URLs on actual mobile devices
      if (osPlatform && (osPlatform === "ios" || osPlatform === "android")) {
        try {
          appUrl = getCorrespondingAppUrl(osPlatform, customerId);
        } catch (platformErr) {
          console.warn("Platform-specific URL building failed", platformErr);
          appUrl = buildAppDownloadUrl(
            baseAppDownloadUrl,
            ctaRef,
            defaultStoreUrl
          );
        }
      } else {
        // Use web URL for desktop/unsupported platforms
        appUrl = buildAppDownloadUrl(
          baseAppDownloadUrl,
          ctaRef,
          defaultStoreUrl
        );
      }

      setAppDownloadUrl(appUrl);
    } catch (err) {
      console.warn("using base URL", err);
      setAppDownloadUrl(baseAppDownloadUrl);
    } finally {
      setIsLoading(false);
    }
  }, [osPlatform, customerId, baseAppDownloadUrl, ctaRef, defaultStoreUrl]);

  return { appDownloadUrl, osPlatform, isLoading };
};

useGetAppDownloadUrl.propTypes = {
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired
};
